import React from 'react';
import { observer } from 'src/utils/mobx-react';

import { ShortEventsListElement } from './ShortEventsListElement';

interface PropsType {
    events: Array<number>,
}

export const ShortEventsList = observer('ShortEventsList', (props: PropsType) => {
    const { events } = props;

    const elements = events.map(eventId => {
        return (
            <ShortEventsListElement
                key={ eventId }
                eventId={eventId}
            />
        );
    });
    return (
        <ul className='short-events-list'>
            { elements }
        </ul>
    );
});

